import CloseIcon from '@mui/icons-material/Close';

/**
 * TitleBar actions factory — same pattern as JxClockTestTitleBarActions.
 * @param {function} onClose - injected from JxWindowManager.closeWindow
 */
export const TITLE_BAR_ACTIONS = (onClose) => [
    { icon: <CloseIcon sx={{ fontSize: 16 }} />, title: 'Close', onClick: onClose },
];
